import React, { createContext, useContext, useMemo } from 'react';
import { inferLocationFromHost } from '@/lib/location';

const LocationContext = createContext<string>('toronto');

export function LocationProvider({ children }: { children: React.ReactNode }) {
  const value = useMemo(() => inferLocationFromHost(window.location.hostname), []);
  
  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation() {
  return useContext(LocationContext);
}

export function getLocation() {
  return inferLocationFromHost(window.location.hostname);
}
